import { useStaticQuery, graphql } from "gatsby"

export const useGetServiceCategories = () => {
  const { services } = useStaticQuery(
    graphql`
      query ServiceCategoriesQuery {
        services: allMarkdownRemark(
          filter: {
            fileAbsolutePath: { regex: "/(/content/service_categories)/" }
          }
        ) {
          edges {
            node {
              frontmatter {
                cat_id
                name
                description
                category
              }
              fields {
                slug
              }
            }
          }
        }
      }
    `
  )
  return services
}
